import { useConfirmationDialog } from '@dashhudson/dashing-ui/confirmation-dialog';
import { useDashToast as useToast } from '@dashhudson/dashing-ui/toast';

import {
  DELETE_CONVERSATION_CONFIRMATION_MESSAGE,
  VISION_AI_WIDGET_INTERACTIONS,
} from '@/components/VisionAi/constants';
import { aiWidgetInteractionEvent } from '@/components/VisionAi/utils/mixpanel-events';
import { useVisionAiConversationsStore } from '@/stores/vision-ai-conversations';

type DeleteConversationTarget = {
  conversationId: number;
  isSummary: boolean;
};

export function useDeleteConversationConfirmation() {
  const visionAiConversationsStore = useVisionAiConversationsStore();
  const { addToast } = useToast({ life: 5000 });

  const { showConfirmationDialog } = useConfirmationDialog({
    group: 'global',
    header: 'Delete Chat?',
    message: DELETE_CONVERSATION_CONFIRMATION_MESSAGE,
    acceptLabel: 'Delete',
    acceptSeverity: 'danger',
  });

  async function confirmDeleteConversation({
    conversationId,
    isSummary,
  }: DeleteConversationTarget) {
    const confirmed = await showConfirmationDialog();
    if (!confirmed) return;

    aiWidgetInteractionEvent({
      interaction: isSummary
        ? VISION_AI_WIDGET_INTERACTIONS.DELETE_SUMMARIES
        : VISION_AI_WIDGET_INTERACTIONS.DELETE_SINGLE_CHAT,
    });

    try {
      await visionAiConversationsStore.deleteConversation({ conversationId, isSummary });
    } catch {
      addToast({
        message: 'This chat could not be deleted.',
        severity: 'error',
      });
    }
  }

  return { confirmDeleteConversation };
}
